module.exports = __webpack_public_path__ + "static/media/landing_meet_11.5e6d2cfc.png";